module.exports = __webpack_public_path__ + "resource/img/contacts.2a60e840.svg";